module.exports = __webpack_public_path__ + "img/pdf.34fbc8ee.png";